export const isGuestAuthEnabled = (): boolean => {
  return process.env.REACT_APP_ENABLE_GUEST_AUTH === "true";
};

/** legacy GuestAuthProvider가 세션 복구에 쓰는 저장소 key. */
export const STORED_GUEST_SESSION_KEY = "guestUser";

/**
 * 저장된 Guest 세션을 비운다.
 *
 * AuthContext.logout은 firebaseToken만 지우므로 이 값이 남으면 GuestAuthProvider가
 * 다시 Guest를 복구하고, Topbar의 guest 판정도 계속 참으로 남는다.
 */
export const clearStoredGuestSession = (): void => {
  try {
    localStorage.removeItem(STORED_GUEST_SESSION_KEY);
  } catch {
    // Private mode 등 저장소 접근 실패는 로그아웃을 막을 이유가 아니다.
  }
};
